import { createSlice } from '@reduxjs/toolkit';

export const deafultActorsSlice = createSlice({
  name: 'deafultActors',
  initialState: {
    actors: [
      {data: {name: "Paweł Małaszyński"}},
      {data: {name: "Maciej Stuhr"}}, 
      {data: {name: "Piotr Adamczyk"}},
      {data: {name: "Wojciech Mecwaldowski"}} ],
    zwrotyAkcji: [
      {data: {name: "dowiaduja sie, ze armor nie zwieksza ich magic resista."}}, 
      {data: {name: "ich adoptowany syn okazuje sie byc reptalianinem."}}, 
      {data: {name: "spotykaja Czlowieko-Niedzwiedzio-Swinie."}}, 
      {data: {name: "zdaja sobie sprawe, ze dobry salceson jest wart 20zl."}},
      {data: {name: "spotykaja wojownika z przyszlosci"}} ],
    pytania: [
      {data: {name: "Ale czy fizyka kwantowa ma realny wplyw na ich zycie?"}}, 
      {data: {name:"Ale czy ich kot zostanie astronauta?"}}, 
      {data: {name: "Ale co stanie sie, kiedy zjedza nietoperza?"}}, 
      {data: {name: "Ale czy warto bylo kochac tak, az do bolu?"}}, 
      {data: {name: "Ale czy zdobeda swiat uzywajac DOTYKU MOTYLA?!"}} ],
  },
});

export const selectDeafultActors = (state) => state.deafultActors.actors;
export const selectDeafultZwrotyAkcji = (state) => state.deafultActors.zwrotyAkcji;
export const selectDeafultPytania = (state) => state.deafultActors.pytania;
export default deafultActorsSlice.reducer;
